import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  hasFilters: boolean
}

const EmptyWebhookDeliveriesComponent = ({ hasFilters }: Props) => {
  return (
    <div
      data-testid="webhook-deliveries-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center gap-1`}
    >
      <Typography variant="subtitle1">
        {hasFilters ? 'No deliveries match these filters' : 'No deliveries yet'}
      </Typography>
      <Typography variant="body2" css={tw`text-shades-500`}>
        {hasFilters
          ? 'Clear the filters to see every delivery for this customer.'
          : 'Deliveries appear here once an event is sent to this customer.'}
      </Typography>
    </div>
  )
}

export const EmptyWebhookDeliveries = memo(EmptyWebhookDeliveriesComponent)
